module.exports = __webpack_public_path__ + "img/levelup-background-element-light.b9e63d42.svg";